import {
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import { OktaAuth } from '@okta/okta-auth-js';
import OktaSignIn from '@okta/okta-signin-widget';
import { DSAuthService } from '../../auth.service';
import { IdentityProvider } from '../../enums/identity-providers';
import { AuthOktaConfiguration } from './okta.model';

@Component({
  selector: 'mp-okta',
  templateUrl: './okta.component.html',
  styleUrls: ['./okta.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class OktaComponent implements OnInit, OnDestroy {
  config: AuthOktaConfiguration;
  widget: OktaSignIn;
  routeAfterSuccess: string;
  allowRegistration: boolean;

  constructor(
    private oktaAuth: OktaAuth,
    private router: Router,
    private authService: DSAuthService,
  ) {}

  ngOnInit(): void {
    this.config = this.authService.configuration.okta;
    this.allowRegistration =
      this.authService?.configuration?.registration?.allowRegistration;
    this.routeAfterSuccess =
      this.authService.configuration.routeAfterSuccess || '/home';

    this.authService.configuration.idp !== IdentityProvider.OKTA
      ? this.router.navigate([this.authService.authUrls.login])
      : this.renderWidget();
  }

  setTextLabels() {
    const labels = this.authService.configuration.okta.textLabels;

    this.widget.options.i18n.en = {
      remember: labels.rememberUserCheckboxLabel,
      'password.reset': labels.passwordResetTitle,
      'primaryauth.title': labels.loginTitle,
      'primaryauth.submit': labels.loginSubmitButton,
      'registration.form.title': labels.registrationTitle,
      'registration.form.submit': labels.registrationSubmitButton,
      'registration.signup.text': labels.loginRegistrationLink,
    };
  }

  renderWidget() {
    const labels = this.config.textLabels;
    const oktaLabels = {
      remember: labels.rememberUserCheckboxLabel,
      'password.reset': labels.passwordResetTitle,
      'primaryauth.title': labels.loginTitle,
      'primaryauth.submit': labels.loginSubmitButton,
      'registration.form.title': labels.registrationTitle,
      'registration.form.submit': labels.registrationSubmitButton,
      'registration.signup.text': labels.loginRegistrationLink,
    };

    this.widget = new OktaSignIn({
      baseUrl: this.config.baseUrl,
      i18n: {
        en: oktaLabels,
      },
      features: {
        registration: this.allowRegistration,
      },
    });

    this.widget.renderEl(
      {
        el: '#okta-signin-container',
      },
      (res) => {
        if (res.status === 'SUCCESS') {
          this.oktaAuth.signInWithRedirect({
            originalUri: this.routeAfterSuccess,
            sessionToken: res.session.token,
          });
        }
      },
      (err) => {
        throw err;
      },
    );
  }

  ngOnDestroy() {
    if (this.widget) {
      this.widget.remove();
    }
  }
}
